import Icon1 from "@assets/icons/Icon";
import React, { useState } from "react";
import { colors } from "sexy";

type AreaTextFieldProps = {
  label?: string;
  value?: string;
  mandatory?: boolean;
  noborder?: boolean;
  mandatory_length?: number | null;
  onChange?: (value: any) => void;
  setValue?: (value: string) => void;
  className?: string;
  transparent?: boolean;
  focusOnStart?: boolean;
  disabled?: boolean;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  resize?: boolean;
};

export default function AreaTextField(props: AreaTextFieldProps) {
  const {
    label = "",
    value = "",
    mandatory = false,
    noborder = false,
    mandatory_length = null,
    onChange,
    setValue,
    className = "",
    transparent = false,
    focusOnStart = false,
    disabled = false,
    placeholder = "",
    rows = 5,
    maxLength,
    resize,
  } = props;

  const [focus, setFocus] = useState(false);
  const [hovering, setHovering] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;

    // Call onChange if provided

    if (onChange) {
      onChange(newValue);
    }

    // Call setValue if provided (for simpler state management)
    if (setValue) {
      setValue(newValue);
    }
  };

  const handleClear = () => {
    const syntheticEvent = {
      target: { value: "" },
    } as React.ChangeEvent<HTMLTextAreaElement>;

    handleChange(syntheticEvent);
  };

  let has_value = value !== null && value !== undefined && value !== "";
  let mandatory_length_disrespect =
    mandatory_length && value?.length !== mandatory_length && has_value;
  let mandatory_disrespect =
    (mandatory && !value && !focus) || mandatory_length_disrespect;
  let border_color = mandatory_disrespect
    ? "outline-red-400"
    : focus
      ? "outline-black"
      : "";

  // Calculate min height based on rows
  const minHeight = `${rows * 1.5 + 2}rem`; // Approximate line height

  return (
    <div className="flex flex-col gap-1 w-full">
      {label && <div className="text-h4 text-neutral-400 ">{label}</div>}
      <div
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        className={`w-full relative flex flex-row select-none text-black ${className} 
          rounded-xl
          ${
            noborder
              ? ""
              : focus
                ? "ring-4 border ring-neutral-300"
                : mandatory_disrespect
                  ? "ring-1 ring-neutral-300"
                  : "border"
          }
          ${border_color}
          ring-none
          transition
          ease-in-out
          duration-150 
          shadow-sm
          ${
            disabled
              ? "bg-neutral-100 text-shadow_25"
              : transparent
                ? "bg-transparent font-semibold"
                : "bg-white"
          }      
        `}
      >
        {/* Clear button */}
        {!disabled && has_value && (
          <div
            onClick={handleClear}
            className="absolute rounded-full p-2 cursor-pointer transition duration-300 top-2 right-2 text-gray-300 hover:bg-gray-50"
          >
            <Icon1 name="effacer2" size={20} color={colors.neutral_400} />
          </div>
        )}

        {/* Character count */}
        {maxLength && (
          <div className="absolute bottom-2 right-3 text-xs text-gray-400">
            {value.length}/{maxLength}
          </div>
        )}

        <textarea
          id={`textarea-${label}`}
          disabled={disabled}
          placeholder={placeholder}
          value={value === null ? "" : value}
          autoFocus={focusOnStart}
          onChange={handleChange}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          maxLength={maxLength}
          rows={rows}
          className={`
            w-full
            bg-transparent
            rounded-xl
            px-3
            mr-6
           
            border-0
            outline-none
            transition
            ease-in-out
            duration-150
          
            ${maxLength ? "" : ""}
            ${resize ? `resize-y  mb-3 pt-3 pb-0` : "resize-none py-3"}
          `}
          style={{
            fontSize: "14px",
            minHeight: minHeight,
          }}
        />
      </div>
    </div>
  );
}
